import FourFiveColumnContent from '@/features/shared/FourFiveColumnContent';
import { MuiTypography } from '@/features/shared/material-ui';
import clsx from 'clsx';
import React, { memo } from 'react';
import ContentCard from '../shared/ContentCard';
import { CardListRowProps } from './CardListRow.interface';
import useStyles from './CardListRow.styles';

const CardWithTheme = ({ data, cardColor, theme, className }: any): JSX.Element => {
  return (
    <ContentCard
      data={data}
      cardColor={cardColor}
      theme={theme}
      className={className}
      imageType="card"
    />
  );
};

const CardListRow = ({
  content,
  cardColor,
  cardTheme,
  contentButtons,
  theme,
  hasHeader,
  columnNumber,
}: Br.PropsWithContentButtons<CardListRowProps>) => {
  const classes = useStyles({});
  const { contentList = [], listSuperheading: superheading, listTitle: title } = content;
  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <div className={rootClassName}>
      {contentButtons?.content}
      <div className={clsx(classes.headerCard, hasHeader && classes.hasHeader)}>
        {superheading && (
          <MuiTypography
            variant="overline"
            component="div"
            className={classes.superHeading}
            dangerouslySetInnerHTML={{ __html: superheading }}
          />
        )}
        {title && (
          <MuiTypography
            variant="h4"
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
      </div>
      {contentList.length > 0 && (
        <FourFiveColumnContent
          columnCount={columnNumber || 3}
          className={classes.columns}
          columns={contentList.map((card, idx) => {
            return (
              <CardWithTheme
                // eslint-disable-next-line react/no-array-index-key
                key={`card_${idx}`}
                data={card}
                cardColor={cardColor}
                theme={cardTheme}
                className={classes.card}
              />
            );
          })}
        />
      )}
    </div>
  );
};

export default memo(CardListRow);
